import { Icon } from '@iconify/react'
import { useGlobalContext } from '../../../utils/Context'
import { useEffect } from 'react'

function Topbar({ page }: any) {
  const activeTab = () => {
    let active = ''

    switch (page) {
      case 'home':
        active = 'Dashboard'
        break
      case 'export':
        active = 'Export'
        break
      case 'import':
        active = 'Import'
        break
      case 'domestic':
        active = 'Domestic'
        break
      case 'bookings':
        active = 'Platform Bookings'
        break
      case 'api-bookings':
        active = 'API Bookings'
        break
      case 'floating-bookings':
        active = 'Floating Bookings'
        break
      case 'All-bookings':
        active = 'All Bookings'
        break

      case 'booking':
        active = 'Booking Details'
        break
      case 'drafts':
        active = 'Drafts'
        break
      case 'over-drafts':
        active = 'Over Draft'
        break
      case 'transactions':
        active = 'Web Transactions'
        break
      case 'api-transactions':
        active = 'API Transactions'
        break
      case 'customers':
        active = 'Customers'
        break
      case 'customer':
        active = 'Customer Details'
        break
      case 'kyc-review':
        active = 'KYC Verification'
        break
      case 'kyc-request':
        active = 'KYC Review'
        break
      case 'shipper-ids':
        active = 'Shipper IDs'
        break
      case 'shipper-id':
        active = 'Shipper ID'
        break
      case 'sender-id-checks':
        active = 'Sender ID Checks'
        break
      case 'trackings':
        active = 'Package Tracking'
        break
      case 'tracking':
        active = 'Package Tracking'
        break
      case 'admins':
        active = 'Admins'
        break
      case 'admin':
        active = 'Admin Details'
        break
      case 'user-rates':
        active = 'User Rates'
        break
      case 'onboarding-requests':
        active = 'Onboarding Requests'
        break
      case 'businesses':
        active = 'Businesses'
        break
      case 'business':
        active = 'Business Details'
        break
      case 'analytics':
        active = 'Analytics'
        break
      case 'debt-customers':
        active = 'Debt Customers'
        break
      case 'balance-customers':
        active = 'Balance Customers'
        break
      case 'notifications':
        active = 'Notifications'
        break
      case 'portal-config':
        active = 'Portal Configuration'
        break
      case 'escalations':
        active = 'QC Buddy — Escalations'
        break
      case 'escalation':
        active = 'Escalation Details'
        break
      case 'knowledge-base':
        active = 'QC Buddy — Knowledge Base'
        break
      case 'knowledge-base-entry':
        active = 'Knowledge Base Entry'
        break
      default:
        break
    }
    return active
  }
  const { profile, handleSidebarToggle, fetchUserProfile } = useGlobalContext()
  useEffect(() => {
    fetchUserProfile()
  }, [])

  return (
    <div className='topbar flex items-center'>
      <div className=' row flex items-center justify-between'>
        <div className='one flex items-center'>
          <div className='icon'>
            <Icon icon={'fa6-solid:bars'} onClick={handleSidebarToggle} />
          </div>
          <h1>{activeTab()}</h1>
        </div>
        <div className='two'>
          <h2>{profile ? `${profile.name}` : 'loading...'}</h2>
          <p>{profile.role}</p>
        </div>
      </div>
    </div>
  )
}

export default Topbar
